// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
@media (max-width: 37.4rem) {
  .style_hide-sm__hFOgf {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__CLBWs {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__sh2q_ {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__lkBxH {
    display: none !important;
  }
}
.style_popoverMenu__VAQrP a {
  color: var(--colorBackgroundPrimaryDefault);
}
.style_pagingControlButton__lOkPZ {
  cursor: pointer;
  border: 0;
  padding: 0 0.25rem;
  margin: 0 0.0625rem;
  min-width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.125rem;
  background-color: var(--colorBackgroundPrimaryDefault);
  color: var(--colorTextTertiary);
}
@media (max-width: 37.4rem) {
  .style_pagingControlButton__lOkPZ {
    width: 2rem;
    height: 2rem;
  }
}
.style_pagingControlButton__lOkPZ:hover,
.style_pagingControlButton__lOkPZ:focus {
  background-color: var(--colorTextTertiary);
  color: var(--colorBackgroundPrimaryDefault);
  outline: 0;
}
.style_pagingControlButton__lOkPZ:active {
  background-color: var(--colorBackgroundPrimaryDefault);
  color: var(--colorTextTertiary);
}
.style_pagingControlButton__lOkPZ .style_pagingControlButtonText___msiz {
  width: 0.5rem;
  height: 1.25rem;
  font-family: Roboto;
  font-size: 0.75rem;
  /* mark.siedle: This differs from the styleguide on purpose ... in double digits 14px looked too crammed */
  line-height: 1.36rem;
  text-align: left;
}
.style_pagingControlButtonActive__Wkukb {
  background-color: var(--colorTextTertiary);
  color: var(--colorBackgroundPrimaryDefault);
}
.style_pagingControlButtonInactive__LeRw7 {
  background-color: var(--colorBackgroundPrimaryDefault);
  color: var(--colorTextTertiary);
}
.style_buttonWrapper__cQYNJ {
  display: inline-block;
}
.style_globalActionButtonAndLinks__OvmpH {
  white-space: nowrap !important;
  /* mark.siedle - Needed to stop buttons wrapping when HTML gets squished (ie. Task "Try again" button) */
}
.style_globalActionButton__tuXTQ {
  font-size: initial !important;
  /* mark.siedle - Needed to stop MaterialUI setting this as 'inherit' which slightly offsets things from aligning horizontally next to text. */
}
`, "",{"version":3,"sources":["webpack://./app/components/Button/style.less","webpack://./app/resources/styles/media.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;ACNF;EACE;IACE,wBAAA;EDQF;AACF;ACLA;EACE;IACE,wBAAA;EDOF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;AA7BA;EACI,2CAAA;AA+BJ;AA5BA;EACI,eAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,sDAAA;EACA,+BAAA;AA8BJ;AA5BI;EAAA;IACI,WAAA;IACA,YAAA;EA+BN;AACF;AA7BI;;EACI,0CAAA;EACA,2CAAA;EACA,UAAA;AAgCR;AA7BI;EACI,sDAAA;EACA,+BAAA;AA+BR;AAvDA;EA4BQ,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EA8BN,0GAA0G;EA7BpG,oBAAA;EACA,gBAAA;AA+BR;AA3BA;EACI,0CAAA;EACA,2CAAA;AA6BJ;AA1BA;EACI,sDAAA;EACA,+BAAA;AA4BJ;AAzBA;EACI,qBAAA;AA2BJ;AAxBA;EACI,8BAAA;EA0BF,wGAAwG;AAC1G;AAxBA;EACI,6BAAA;EA0BF,6IAA6I;AAC/I","sourcesContent":["@import \"../../resources/styles/colors.less\";\n@import \"../../resources/styles/media\";\n\n.popoverMenu a {\n    color: @white;\n}\n\n.pagingControlButton {\n    cursor: pointer;\n    border: 0;\n    padding: 0 0.25rem; // Required in the event of long-content.\n    margin: 0 0.0625rem;\n    min-width: 1.75rem; // min-width required in the event of long-content.\n    height: 1.75rem;\n    border-radius: 0.125rem;\n    background-color: @white;\n    color: @secondaryText;\n\n    @media (max-width: @screen-sm) { // Make the touch area larger for iPhone/touch situations.\n        width: 2rem;\n        height: 2rem;\n    }\n\n    &:hover, &:focus {\n        background-color: @secondaryText;\n        color: @white;\n        outline:0;\n    }\n\n    &:active {\n        background-color: @white;\n        color: @secondaryText;\n    }\n\n    .pagingControlButtonText {\n        width: 0.5rem;\n        height: 1.25rem;\n        font-family: Roboto;\n        font-size: 0.75rem; /* mark.siedle: This differs from the styleguide on purpose ... in double digits 14px looked too crammed */\n        line-height: 1.36rem;\n        text-align: left;\n    }\n}\n\n.pagingControlButtonActive {\n    background-color: @secondaryText;\n    color: @white;\n}\n\n.pagingControlButtonInactive {\n    background-color: @white;\n    color: @secondaryText;\n}\n\n.buttonWrapper {\n    display: inline-block;\n}\n\n.globalActionButtonAndLinks {\n    white-space: nowrap !important; /* mark.siedle - Needed to stop buttons wrapping when HTML gets squished (ie. Task \"Try again\" button) */\n}\n\n.globalActionButton {\n    font-size: initial !important; /* mark.siedle - Needed to stop MaterialUI setting this as 'inherit' which slightly offsets things from aligning horizontally next to text. */\n}","//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__hFOgf`,
	"hideSm": `style_hide-sm__hFOgf`,
	"visible-sm": `style_visible-sm__CLBWs`,
	"visibleSm": `style_visible-sm__CLBWs`,
	"hide-md": `style_hide-md__sh2q_`,
	"hideMd": `style_hide-md__sh2q_`,
	"visible-md": `style_visible-md__lkBxH`,
	"visibleMd": `style_visible-md__lkBxH`,
	"popoverMenu": `style_popoverMenu__VAQrP`,
	"pagingControlButton": `style_pagingControlButton__lOkPZ`,
	"pagingControlButtonText": `style_pagingControlButtonText___msiz`,
	"pagingControlButtonActive": `style_pagingControlButtonActive__Wkukb`,
	"pagingControlButtonInactive": `style_pagingControlButtonInactive__LeRw7`,
	"buttonWrapper": `style_buttonWrapper__cQYNJ`,
	"globalActionButtonAndLinks": `style_globalActionButtonAndLinks__OvmpH`,
	"globalActionButton": `style_globalActionButton__tuXTQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
